interface GradientPeopleIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const GradientPeopleIcon: React.FC<GradientPeopleIconProps> = ({
  width = 18,
  height = 18,
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      role="img"
      aria-label="Gradient People Icon"
    >
      <g filter="url(#filter0_iii_6323_6664)">
        <path
          d="M8.41123 13.9434H15.3225C15.7553 13.9434 16.0598 13.8811 16.2359 13.7563C16.412 13.6353 16.5 13.4537 16.5 13.2116C16.5 12.8594 16.3918 12.4871 16.1753 12.0946C15.9626 11.702 15.6544 11.3352 15.2509 10.994C14.8511 10.6492 14.365 10.3704 13.7927 10.1577C13.2241 9.94122 12.5822 9.833 11.8668 9.833C11.1552 9.833 10.5132 9.94122 9.94094 10.1577C9.37234 10.3704 8.88628 10.6492 8.48276 10.994C8.07924 11.3352 7.77109 11.702 7.55833 12.0946C7.34556 12.4871 7.23918 12.8594 7.23918 13.2116C7.23918 13.4537 7.32539 13.6353 7.4978 13.7563C7.67388 13.8811 7.97836 13.9434 8.41123 13.9434ZM11.8723 8.84804C12.2649 8.84804 12.628 8.74166 12.9618 8.52889C13.2957 8.31246 13.5635 8.02082 13.7652 7.65399C13.967 7.28715 14.0679 6.87446 14.0679 6.41591C14.0679 5.9647 13.967 5.56118 13.7652 5.20534C13.5635 4.84584 13.2957 4.56338 12.9618 4.35795C12.628 4.15252 12.2649 4.0498 11.8723 4.0498C11.4798 4.0498 11.1167 4.15435 10.7828 4.36345C10.449 4.57255 10.1794 4.85685 9.97395 5.21635C9.77219 5.57585 9.67131 5.97937 9.67131 6.42691C9.67131 6.88179 9.77219 7.29265 9.97395 7.65949C10.1757 8.02266 10.4435 8.31246 10.7773 8.52889C11.1112 8.74166 11.4762 8.84804 11.8723 8.84804ZM2.46845 13.9434H6.6449C6.50183 13.7343 6.43397 13.483 6.44131 13.1896C6.44864 12.8961 6.51651 12.588 6.6449 12.2651C6.77329 11.9423 6.94938 11.6305 7.17315 11.3297C7.40059 11.0252 7.66288 10.7574 7.96001 10.5263C7.65187 10.3209 7.29787 10.1522 6.89802 10.0201C6.50183 9.88436 6.04696 9.8165 5.53338 9.8165C4.91343 9.8165 4.354 9.91921 3.8551 10.1246C3.35987 10.3264 2.93617 10.5942 2.58401 10.928C2.23551 11.2582 1.96772 11.6195 1.78063 12.012C1.59354 12.4045 1.5 12.7916 1.5 13.1731C1.5 13.4188 1.57337 13.6078 1.7201 13.7398C1.87051 13.8756 2.11996 13.9434 2.46845 13.9434ZM5.53338 8.9746C5.87821 8.9746 6.19552 8.88106 6.48533 8.69397C6.77513 8.50688 7.00807 8.25377 7.18415 7.93462C7.36023 7.6118 7.44828 7.2523 7.44828 6.85611C7.44828 6.45993 7.36023 6.10776 7.18415 5.79962C7.00807 5.48781 6.77329 5.24386 6.47982 5.06778C6.19002 4.88803 5.87454 4.79815 5.53338 4.79815C5.19589 4.79815 4.88041 4.88986 4.58694 5.07328C4.29714 5.25303 4.06236 5.49881 3.88261 5.81063C3.70286 6.12244 3.61482 6.4746 3.61849 6.86712C3.61849 7.25964 3.70653 7.61547 3.88261 7.93462C4.05869 8.25377 4.29164 8.50688 4.58144 8.69397C4.87491 8.88106 5.19222 8.9746 5.53338 8.9746Z"
          fill="url(#paint0_linear_6323_6664)"
        />
      </g>
      <defs>
        <filter
          id="filter0_iii_6323_6664"
          x="0.692026"
          y="4.0498"
          width="18.4627"
          height="11.8936"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.577124" />
          <feGaussianBlur stdDeviation="0.577124" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6323_6664" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="2" />
          <feGaussianBlur stdDeviation="1.32739" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.417787 0 0 0 0 0.266522 0 0 0 0 0.767954 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_6323_6664"
            result="effect2_innerShadow_6323_6664"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.807974" dy="0.23085" />
          <feGaussianBlur stdDeviation="0.461699" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6323_6664"
            result="effect3_innerShadow_6323_6664"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6323_6664"
          x1="1.5"
          y1="4.0498"
          x2="16.621"
          y2="4.23826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF45A9" />
          <stop offset="1" stopColor="#FF6A6A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientPeopleIcon;
